export enum MotifMailCategorie {
  REFUS = 'REFUS',
  DEMANDE_INFORMATION = 'DEMANDE_INFORMATION',
  RELANCE = 'RELANCE',
}

export const MotifMailAllCategories: MotifMailCategorie[] =
  [MotifMailCategorie.REFUS,
    MotifMailCategorie.DEMANDE_INFORMATION,
    MotifMailCategorie.RELANCE];